import ContactFields from "../components/Contact/ContactFields.js";
import ContentCard from "../components/ContentCard/ContentCard";
import "../stylesheets/contact.css";

export default function ContactPage() {
  return (
    <div className="Contact">
      <h1>Contact Me</h1>
      <ContentCard>
        <ContactFields />
      </ContentCard>
    </div>
  );
}
